window.Products.Bag.VeganLeatherBackpack = function () {}
window.Products.Bag.VeganLeatherBackpack.inherits(window.Products.Bag.Bag)